export class ConversionMigrationStep {
	step: number;
	action: string;
	/** Success, Failed or Skipped. */
	status: string;
	detail: string;
}

/** One client's line of the invoice summary report (step 12, Create invoice export files). */
export class ConversionInvoiceExportSummaryRow {
	clientCode: string;
	clientName: string;
	invoicesToImport: number;
	amountToImport: number;
	debtors: number;
	earliestInvoiceDate: string;
	latestInvoiceDate: string;
	exportFiles: string[];
	invoicesNotSent: number;
	amountNotSent: number;
	invoicesNotWritten: number;
}

export class ConversionMigrationResult {
	clientName: string;
	clientKeys: number[];
	/** 1 = Part 1 (steps 1-11), 2 = Part 2 (steps 12-23), 3 = the full conversion (steps 1-23). */
	part: number;
	successful: boolean;
	/** Step 1 found the client already in FactorCloud (not the conversion's), so the carrier was ignored. */
	ignored: boolean;
	/** When the carrier's run started and finished (UTC), and how long it ran for. */
	startedOn: string;
	finishedOn: string;
	ranFor: string;
	/** Step 12: this carrier's lines of the invoice summary report. */
	invoiceExportSummary: ConversionInvoiceExportSummaryRow[];
	factorCloudClientId: string;
	debtorsCreated: number;
	invoicesCreated: number;
	failedAtStep: number;
	summary: string;
	steps: ConversionMigrationStep[];
	/** Open WinFactor invoices with a negative balance, not posted to FactorCloud. */
	skippedNegativeInvoices: ConversionSkippedInvoice[];
	/** Data problems the conversion worked around (e.g. an invalid EIN that was skipped). */
	exceptions: ConversionException[];
	/** Step 9: FactorCloud's failed rows of the invoice CSV import, saved as {file}_errors.csv (download by name). */
	invoiceImportErrorFiles: string[];
	/** Set when step 1 failed with "The company code X is already registered.". */
	codeConflict: ConversionCodeConflict;
}

/** A company code FactorCloud would not create the carrier with because another company already has it. */
export class ConversionCodeConflict {
	/** The carrier's code (its ClientNo). */
	code: string;
	/** The code the owning company would be changed to (code + 8888). */
	newCode: string;
	/** FactorCloud companies that have the code (normally one). */
	owners: ConversionCodeOwner[];
}

/** A FactorCloud client or debtor that has a company code. */
export class ConversionCodeOwner {
	id: string;
	/** client or debtor. */
	companyType: string;
	companyName: string;
	active: boolean;
}

/** Outcome of changing a FactorCloud company's code. */
export class ConversionRecodeCompanyResult {
	companyId: string;
	companyType: string;
	companyName: string;
	oldCode: string;
	newCode: string;
}

/** One data problem the conversion worked around for a carrier. */
export class ConversionException {
	clientName: string;
	clientNo: string;
	winFactorId: number;
	issue: string;
	value: string;
	action: string;
}

/** A WinFactor invoice the conversion did not post to FactorCloud, and why. */
export class ConversionSkippedInvoice {
	clientName: string;
	clientNo: string;
	invoiceNo: string;
	purchaseOrder: string;
	debtorName: string;
	invoiceDate: string;
	dueDate: string;
	invoiceAmount: number;
	balance: number;
	reason: string;
}



// WEBPACK FOOTER //
// ./src/app/portal/conversion/models/ConversionMigrationResult.ts